import React from 'react'

export default function ContactMe() {
  return (
    <footer class="footer" id='ContactMe'>
        <div class="footer-container">
            <div class="contact-info">
                <p>Email: <a href="mailto:kuntumallavenkatasanjeeva2005@gmail.com" rel="noopener noreferrer">kuntumallavenkatasanjeeva2005@gmail.com</a></p>
                <p>Phone: <a href="tel:+918186863951" rel="noopener noreferrer">+91 8186863951</a></p>
            </div>

            <div class="social-media">
                <h3>Follow Me</h3>
                <a href="https://www.linkedin.com/in/venkata-sanjeeva-kuntumalla-ab5894257/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
                <a href="https://github.com/Venkata-Sanjeeva" target="_blank" rel="noopener noreferrer">GitHub</a>
            </div>
        </div>
        <div class="footer-tagline">
            <p>© 2024 Venkata Sanjeeva Kuntumalla. All rights reserved.</p>
        </div>
    </footer>

  )
}
